import { render, staticRenderFns } from "./updateNameModal.vue?vue&type=template&id=381b6fd6&scoped=true&"
import script from "./updateNameModal.vue?vue&type=script&lang=js&"
export * from "./updateNameModal.vue?vue&type=script&lang=js&"
import style0 from "./updateNameModal.vue?vue&type=style&index=0&id=381b6fd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381b6fd6",
  null
  
)

export default component.exports